import { createRoot } from "react-dom/client";
import { flushSync } from "react-dom";
import { LEGEND_FONT_FAMILY } from "../LegendBox";
import { LEGEND_TEXT_COLOR } from "../LegendBox/constants";
import {
  NOTE_PAGE_LABEL_COLOR,
  NOTE_PAGE_LABEL_FONT_SIZE,
  NOTE_TITLE_FONT_SIZE,
} from "../appendNotePages/constants";
import { NoteEntrySvg } from "./NoteEntrySvg";
import type { RenderNotePageSvgString } from "./types";

export const renderNotePageSvgString: RenderNotePageSvgString = ({
  pdfPageWidth,
  pdfPageHeight,
  pixelWidth,
  pixelHeight,
  metrics,
  title,
  pageLabel,
  continuedLabel,
  entries,
  page,
}) => {
  const titleFontSize = NOTE_TITLE_FONT_SIZE * metrics.scale;
  const titleBaselineY = metrics.titleTop + titleFontSize;

  const detachedContainer = document.createElement("div");
  const root = createRoot(detachedContainer);

  try {
    flushSync(() => {
      root.render(
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox={`0 0 ${pdfPageWidth} ${pdfPageHeight}`}
          width={pixelWidth}
          height={pixelHeight}
        >
          <text
            x={metrics.margin}
            y={titleBaselineY}
            fontFamily={LEGEND_FONT_FAMILY}
            fontSize={titleFontSize}
            fontWeight={600}
            fill={LEGEND_TEXT_COLOR}
          >
            {title}
          </text>
          <text
            x={pdfPageWidth - metrics.margin}
            y={titleBaselineY}
            textAnchor="end"
            fontFamily={LEGEND_FONT_FAMILY}
            fontSize={NOTE_PAGE_LABEL_FONT_SIZE * metrics.scale}
            fill={NOTE_PAGE_LABEL_COLOR}
          >
            {pageLabel}
          </text>
          {page.segments.map((segment, index) => (
            <NoteEntrySvg
              key={`${segment.entryIndex}-${index}`}
              segment={segment}
              entry={entries[segment.entryIndex]}
              metrics={metrics}
              continuedLabel={continuedLabel}
            />
          ))}
        </svg>,
      );
    });

    const svgElement = detachedContainer.querySelector("svg");
    if (!svgElement) {
      throw new Error("SVG element not found in note page render output");
    }

    return new XMLSerializer().serializeToString(svgElement);
  } finally {
    root.unmount();
  }
};
